import { motion } from "framer-motion";

const members = [
  {
    id: "halil-tolga-kaya",
    name: "Halil Tolga Kaya",
    role: "President",
    image: "/team/president/halil-tolga-kaya.png",
  },
  {
    id: "mert-dayioglu",
    name: "Mert Nihad Dayıoğlu",
    role: "Vice President and High School Coordinator",
    image: "/team/mert-dayioglu.jpg",
  },
  // {
  //   id: "tuna-altikardesler",
  //   name: "Tuna Altıkardeşler",
  //   role: "Vice President",
  //   image: "/team/tuna-altikardesler.jpg",
  // },
  {
    id: "tuna-tiryaki",
    name: "Tuna Tiryaki",
    role: "Board Member",
    image: "/team/tuna-tiryaki.jpg",
  },
  {
    id: "hanzade-aras",
    name: "Hanzade Aras",
    role: "Secretary General",
    image: "/team/hanzade-aras.jpeg",
  },
  // {
  //   id: "kent-umut",
  //   name: "Kent Umut",
  //   role: "Yönetim Kurulu Üyesi",
  //   image: "/team/kent-umut.jpg",
  // },
];

const YonetimKurulu = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-[#0A0A0A] via-[#111111] to-[#0A0A0A] pt-36 pb-12">
      <div className="absolute inset-0 bg-[url('/noise.png')] opacity-5 pointer-events-none"></div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h1 className="text-4xl sm:text-5xl font-bold text-white mb-6">
            Board of Directors
          </h1>
          <p className="text-lg sm:text-xl text-gray-400 max-w-3xl mx-auto">
            Our esteemed team members who shape the vision of Kolektif Oluşum
            and carry it into the future
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8"
        >
          {members.map((member, index) => (
            <motion.div
              key={member.id}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="group flex flex-col items-center p-6 bg-white/5 backdrop-blur-sm rounded-2xl border border-white/10 hover:bg-white/10 transition-all duration-300"
            >
              <div className="w-32 h-32 mb-6 rounded-full overflow-hidden border-2 border-white/20 group-hover:border-blue-500/50 transition-colors duration-300">
                <img
                  src={member.image}
                  alt={member.name}
                  className="w-full h-full object-cover"
                />
              </div>
              <h3 className="text-xl font-semibold text-white text-center group-hover:text-blue-400 transition-colors duration-300">
                {member.name}
              </h3>
              <p className="text-gray-400 mt-2 text-center group-hover:text-gray-300 transition-colors duration-300">
                {member.role}
              </p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default YonetimKurulu;
